import React from 'react';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';
import { ISelectOption } from '../../../domain/saved-filters/interface';

interface ISiteFilterSelectProps {
    value: (number | string)[];
    onChange: (value: (number | string)[]) => void;
    onSearch?: (value: string) => void;
    label?: string;
    height?: number;
    searchable?: boolean;
    disabled?: boolean;
    resizable?: boolean;
    options: ISelectOption<number | string>[];
    isLoading?: boolean;
}

export const SiteFilterSelect: React.FC<ISiteFilterSelectProps> = ({
    options,
    value,
    onChange,
    label,
    height = 300,
    searchable = true,
    disabled = false,
    resizable = true,
    isLoading = false,
}) => {
    return (
        <BaseFilterCheckboxSelect
            multiple
            resizable={resizable}
            loading={isLoading}
            searchable={searchable}
            showSelectAllOption={false}
            selectedCountInLabel
            disabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            height={height}
        />
    );
};
